import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { UserService } from 'src/app/core/services/user.service';
import { AdminService } from '../admin.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ApproverMapModel } from 'src/app/core/models/ApproverMapModel';
import { DepartmentModel } from 'src/app/core/models/DepartmentModel';
import { SubDepartmentModel } from 'src/app/core/models/SubDepartmentModel';
import { RegisteredUserModel } from 'src/app/core/models/RegisteredUserModel';
import { User } from 'src/app/core/models/user';
import { ApplicationRole } from 'src/app/core/models/ApplicationRole';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-department-approvers',
  standalone: false,
  templateUrl: './department-approvers.component.html',
  styleUrl: './department-approvers.component.less'
})
export class DepartmentApproversComponent  implements OnInit {

  approverForm!: FormGroup; // Reactive form instance
  isVisible = false; // Modal visibility
  isEditMode = false; // Determines if the form is in edit mode
  isConfirmLoading = false; // Loading state for the confirm button
  isConfirmLoadingForCreateButton = false; // Loading state for the confirm button

  deptApproverDetails: ApproverMapModel[] = [];
  departmentMaster: DepartmentModel[] = [];
  subDeptMaster: SubDepartmentModel[]=[];
  deptSubDeptMaster: SubDepartmentModel[]=[];
  canSelectApprovers : boolean = false;
  errorMsg : string='';

  JVUserMaster: RegisteredUserModel[] = [];
  deptRepresentvMaster: RegisteredUserModel[] = [];
  deptViewrMaster: RegisteredUserModel[] = [];

  currentUser: User = new User();
  selectedDeptApproverMap = new ApproverMapModel();
  selectedDeptRepsen = [];
  selectedDeptViewer = [];

  dropdownSettings = {};
  loadExistingDepRepsn = false;

  searchText: string = "";
  config: any;
  currentPageSize = 10;
  sortingName: string = "Department_Name";
  isDesc: boolean = false;
  
  constructor(private router: Router,
    private fb: FormBuilder,
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private userService: UserService,
    private adminService: AdminService,
    private dbMasterService: DbMasterService
  ) {
    
  }
  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    this.selectedDeptApproverMap.Created_By = this.currentUser.User_Code??0;
    if (this.currentUser.IsRFCAdmin) {
     this.getAllApprovers();
     this.initialiseData();
     this.initializeApproverForm();
    }
    else {
      this.router.navigate(['/unauthorize']);
    }
    
  }
  // Initialize the reactive form
  initializeApproverForm(): void {
    this.approverForm = this.fb.group({
      department: ['', Validators.required],
      subDepartment: ['', Validators.required],
      deptRepresentative: [[], Validators.required], // Multiple selection
      jvAdvisor: ['', Validators.required],
      deptViewer: ['', Validators.required]
    });
  }
  getAllApprovers()
  {
    this.adminService.getAllApprovers().subscribe((response: any) => {
      this.deptApproverDetails = response.output;
      this.fillMasterDetails();
    }, error => {
      this.messageService.error("Error occurred while fetching all approvers details.");
      
    });
  }
  initialiseData() {
    this.sortingName = 'Department_Name';
    this.config = {
      itemsPerPage: this.currentPageSize,
      currentPage: 1,
      totalItems: this.deptApproverDetails.length
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'User_Code',
      textField: 'User_Name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
  fillMasterDetails()
  {
    this.isConfirmLoadingForCreateButton = true;
    this.dbMasterService.getMasterDetails(true).subscribe((response: any) => {
      this.departmentMaster = response.output.Department.filter((dept: DepartmentModel) => dept.Active);
      this.subDeptMaster = response.output.SubDepartment.filter((subDept: SubDepartmentModel) => subDept.Active);
      this.deptSubDeptMaster = [];
      let users = response.output.AllUsers as RegisteredUserModel[];
      this.deptRepresentvMaster = users.filter(user => user.Active && (user.ApplicationRoles.indexOf(ApplicationRole.DeptRepresentative) !== -1))
      this.deptViewrMaster = users.filter(user => user.Active && (user.ApplicationRoles.indexOf(ApplicationRole.DeptViewer) !== -1))
      this.JVUserMaster = users.filter(user => user.Active && (user.ApplicationRoles.indexOf(ApplicationRole.JVAdvisor) !== -1));
      // Reset the loading state for the create button after fetching master details
      this.isConfirmLoadingForCreateButton = false; 
    }, error => {
      this.messageService.error("Error occurred while fetching all details");
      
    });
  }
  // Show the modal for adding a new approver
  showCreateModal(): void {
    this.isEditMode = false;
    this.approverForm.reset();
    this.isVisible = true;
  }

  // Show the modal for editing an existing approver
  showEditModal(approver: ApproverMapModel): void {
    this.isEditMode = true;
    this.selectedDeptApproverMap = { ...approver }; // Create a copy of the approver object
    this.approverForm.patchValue({
      department: approver.Department_Code,
      subDepartment: approver.Sub_Dept_Code,
      deptRepresentative: approver.DeptRepCodes,
      jvAdvisor: approver.JVAdvisorCode,
      deptViewer: approver.DeptViewerCodes
    });
    this.isVisible = true;
  }

  // Handle the modal's OK button
  handleOk(): void {
    if (this.approverForm.valid) {
      const formValue = this.approverForm.value;

      if (this.isEditMode) {
        this.selectedDeptApproverMap.Department_Code = formValue.department;
        this.selectedDeptApproverMap.Sub_Dept_Code = formValue.subDepartment;
        this.selectedDeptApproverMap.DeptRepCodes = formValue.deptRepresentative;
        this.selectedDeptApproverMap.JVAdvisorCode = formValue.jvAdvisor;
        this.selectedDeptApproverMap.DeptViewerCodes = formValue.deptViewer;       
        this.updateApprover();
      } else {
        const newApprover = new ApproverMapModel();
        newApprover.Department_Code = formValue.department;
        newApprover.Sub_Dept_Code = formValue.subDepartment;
        newApprover.DeptRepCodes = formValue.deptRepresentative;
        newApprover.JVAdvisorCode = formValue.jvAdvisor;
        newApprover.DeptViewerCodes = formValue.deptViewer;
        this.addApprover(newApprover);
      }
    }
  }

  // Handle the modal's Cancel button
  handleCancel(): void {
    this.isVisible = false;
    this.approverForm.reset();
    this.isEditMode = false;
  }

  // Add a new approver
  addApprover(approver: ApproverMapModel): void {
    this.adminService.addApprovers(approver).subscribe((response: any) => {
      if (response.result) {
        this.messageService.success('Approver added successfully!');
        this.getAllApprovers();
        this.handleCancel();
      } else {
        this.messageService.error('Failed to add approver.');
      }
    });
  }

  // Update an existing approver
  updateApprover(): void {
    this.adminService.updateApprovers(this.selectedDeptApproverMap).subscribe((response: any) => {
      if (response.result) {
        this.messageService.success('Approver updated successfully!');
        this.getAllApprovers();
        this.handleCancel();
      } else {
        this.messageService.error('Failed to update approver.');
      }
    });
  }
  listOfColumn = [
    {
      title: 'Department',
      compare: (a: ApproverMapModel, b: ApproverMapModel) => (a.Department_Name || '').localeCompare(b.Department_Name || ''),
      priority: 3,
      allowSorting: true
    },
    {
      title: 'Department Status',
      compare: null,
      priority: 2,
      allowSorting: true
    },
    {
      title: 'Sub Department',
      compare: (a: ApproverMapModel, b: ApproverMapModel) => (a.Sub_Dept_Name || '').localeCompare(b.Sub_Dept_Name || ''),
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Dept Representative',
      compare: (a: ApproverMapModel, b: ApproverMapModel) => (a.DeptRepName || '').localeCompare(b.DeptRepName || ''),
      priority: 1,
      allowSorting: true
    }
    ,
    {
      title: 'JV Advisor',
      compare: (a: ApproverMapModel, b: ApproverMapModel) => a.JVAdvisorName.localeCompare(b.JVAdvisorName || ''),
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Dept Viewer',
      compare: (a: ApproverMapModel, b: ApproverMapModel) => (a.DeptViewerName || '').localeCompare(b.DeptViewerName || ''),
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Sub Dept Status',
      compare: null,
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Action',
      compare: null,
      priority: false,
      allowSorting: false
    }
  ];
}
